// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"RemainTimesBtn_overlayClass__GhLkd","activeTabBg":"RemainTimesBtn_activeTabBg__5pqZG"};